import React from 'react';
import { useTranslations } from '@lang';
import { Routes } from '@common/constants';
import { Moment } from 'moment';
import { ProductBox } from './ProductBox';
import { NotFound, ResultsGrid, ResultsWrapper, SingleResult } from './ProductGrid.styles';
import { ProductGridItemType } from './ProductGrid.types';

type ProdcutGridProps = {
  columns?: number;
  items: ProductGridItemType[];
  route?: string;
  showInfoIfNoItems?: boolean;
  renderMetadataRow?: (product: ProductGridItemType) => React.ReactNode;
  hideOptionsRow?: boolean;
  date?: Moment;
  imagesTransparent?: boolean;
};

/**
 * @deprecated use common/features/List
 */
const ProductGrid: React.FC<ProdcutGridProps> = ({
  columns = 4,
  items,
  route = Routes.PRODUCT_DETAIL,
  showInfoIfNoItems = true,
  renderMetadataRow,
  hideOptionsRow,
  date,
}) => {
  const { t } = useTranslations();

  return !!items && items.length > 0 ? (
    <ResultsGrid data-cy="product-grid_results">
      {items.map((item, index) => (
        <SingleResult
          key={item.id}
          columns={columns}
          data-cy="product-grid_single-result"
          data-test={item.name}
          data-test-id={item.id}
        >
          <ProductBox
            product={item}
            route={route}
            renderMetadataRow={renderMetadataRow}
            hideOptionsRow={hideOptionsRow}
            date={date}
            itemIsUnavailable={item.unAvailable}
            index={index}
          />
        </SingleResult>
      ))}
    </ResultsGrid>
  ) : (
    <ResultsWrapper>
      {showInfoIfNoItems && items && !items.length && <NotFound>{t('app.noItemsFound')}</NotFound>}
    </ResultsWrapper>
  );
};

export { ProductGrid };
